module.exports = __webpack_public_path__ + "img/austria-leukaemia-female.07671c1d.png";